export const getuserInfo = (context, pro) => {
    context.commit('getuserInfo', pro);
};
export const clearUserInfo = (context, pro) => {
    context.commit('clearUserInfo', pro);
};
export const setToken = (context, pro) => {
    context.commit('setToken', pro);
};
export const clearToken = (context, pro) => {
    context.commit('clearToken', pro);
};
export const setpasswordLogin = (context, pro) => {
    context.commit('setpasswordLogin', pro);
};
export const clearpasswordLogin = (context, pro) => {
    context.commit('clearpasswordLogin', pro);
};
export const setcallStatus = (context, pro) => {
    context.commit('setcallStatus', pro);
};
export const clearcallStatus = (context, pro) => {
    context.commit('clearcallStatus', pro);
};
export const setringoffBtn = (context, pro) => {
    context.commit('setringoffBtn', pro);
};
export const clearringoffBtn = (context, pro) => {
    context.commit('clearringoffBtn', pro);
};
export const setcallSubmit = (context, pro) => {
    context.commit('setcallSubmit', pro);
};
export const clearcallSubmit = (context, pro) => {
    context.commit('clearcallSubmit', pro);
};
export const setcallLoadingStatus = (context, pro) => {
    context.commit('setcallLoadingStatus', pro);
};
export const clearcallLoadingStatus = (context, pro) => {
    context.commit('clearcallLoadingStatus', pro);
};
export const setcustomerCall = (context, pro) => {
    context.commit('setcustomerCall', pro);
};
export const clearcustomerCall = (context, pro) => {
    context.commit('clearcustomerCall', pro);
};
export const setiframeUrl = (context, pro) => {
    context.commit('setiframeUrl', pro);
};
export const cleariframeUrl = (context, pro) => {
    context.commit('cleariframeUrl', pro);
};
export const setcustomerId = (context, pro) => {
    context.commit('setcustomerId', pro);
};
export const clearcustomerId = (context, pro) => {
    context.commit('clearcustomerId', pro);
};
export const setcustomerSearchType = (context, pro) => {
    context.commit('setcustomerSearchType', pro);
};
export const clearcustomerSearchType = (context, pro) => {
    context.commit('clearcustomerSearchType', pro);
};
export const setcalldialog = (context, pro) => {
    context.commit('setcalldialog', pro);
};
// export const clearpasswordLogin = (context, pro) => {
//     context.commit('clearpasswordLogin', pro);
// };
export const setcalldialogsmall = (context, pro) => {
    context.commit('setcalldialogsmall', pro);
};
export const currentSize = (context, pro) => {
    context.commit('currentSize', pro);
};


// WEBPACK FOOTER //
// ./src/vuex/actions.js